import {
    IBM_Plex_Mono,
    Space_Mono,
    Noto_Serif,
    Manrope,
    Spectral,
} from "next/font/google";
import localFont from "next/font/local";

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export const faktum = localFont({
    variable: "--font-faktum",
    src: [
        {
            path: "./fonts/faktum-bold-webfont.woff",
            weight: "700",
            style: "bold",
        },
        {
            path: "./fonts/faktum-semibold-webfont.woff",
            weight: "600",
            style: "semibold",
        },
        {
            path: "./fonts/faktum-medium.otf",
            weight: "500",
            style: "normal",
        },
        {
            path: "./fonts/faktum-regular-webfont.woff",
            weight: "400",
            style: "normal",
        },
        {
            path: "./fonts/faktum-light-webfont.woff",
            weight: "300",
            style: "light",
        },
        {
            path: "./fonts/faktum-conmedium.otf",
            weight: "200",
            style: "normal",
        },
    ],
});

export const spectral = Spectral({
    subsets: ["latin"],
    weight: ["400", "500", "600", "700", "800"],
    variable: "--font-spectral",
});

export const americanGrotesk = localFont({
    variable: "--font-american-grotesk",
    src: [
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Black.otf",
            weight: "900",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-BlackItalic.otf",
            weight: "900",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Bold.otf",
            weight: "700",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-BoldItalic.otf",
            weight: "700",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Heavy.otf",
            weight: "800",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-HeavyItalic.otf",
            weight: "800",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Italic.otf",
            weight: "400",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Light.otf",
            weight: "300",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-LightItalic.otf",
            weight: "300",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Medium.otf",
            weight: "500",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-MediumItalic.otf",
            weight: "500",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGrotesk-Regular.otf",
            weight: "400",
            style: "normal",
        },
    ],
});

export const americanGroteskCondensed = localFont({
    variable: "--font-american-grotesk-condensed",
    src: [
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGroteskCondensed-Regular.otf",
            weight: "400",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGroteskCondensed-Bold.otf",
            weight: "700",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/AmericanGrotesk/AmericanGroteskCondensed-Heavy.otf",
            weight: "800",
            style: "normal",
        },
    ],
});

export const copernicusNewCond = localFont({
    variable: "--font-copernicus-new-cond",
    src: [
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-070.woff2",
            weight: "300",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-070.woff",
            weight: "300",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-090.woff2",
            weight: "400",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-090.woff",
            weight: "400",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-110.woff2",
            weight: "500",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-110.woff",
            weight: "500",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-130.woff2",
            weight: "600",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-130.woff",
            weight: "600",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-150.woff2",
            weight: "700",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-150.woff",
            weight: "700",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-170.woff2",
            weight: "800",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/CopernicusNewCond/CopernicusNewCond-170.woff",
            weight: "800",
            style: "normal",
        },
    ],
});

export const tiemposText = localFont({
    variable: "--font-tiempos-text",
    src: [
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-Regular.otf",
            weight: "400",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-RegularItalic.otf",
            weight: "400",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-Medium.otf",
            weight: "500",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-MediumItalic.otf",
            weight: "500",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-Semibold.otf",
            weight: "600",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-SemiboldItalic.otf",
            weight: "600",
            style: "italic",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-Bold.otf",
            weight: "700",
            style: "normal",
        },
        {
            path: "./fonts/white-label/freepress/Tiempos Text/TiemposText-BoldItalic.otf",
            weight: "700",
            style: "italic",
        },
    ],
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
